export interface Chapter {
  id: number;
  num: number;
  title: string;
  volume: string;
  date: string;
  pages: number;
}

export interface Character {
  id: number;
  name: string;
  role: string;
  desc: string;
  image: string;
  tag: string;
}

export const volumes = ["第1卷", "第2卷", "第3卷", "第4卷"];

export const chapterTitles = [
  "陌生的香味",
  "借宿的第一天",
  "早起的厨房战争",
  "同款的马克杯",
  "放学后的赌约",
  "雨天的伞只有一把",
  "深夜的零食同盟",
  "交换校服的约定",
  "楼下的小卖部",
  "被发现的日记本",
  "周末的双人计划",
  "她藏起来的照片",
  "邻居的闲言碎语",
  "天台上的烟囱",
  "圣诞节的火锅",
  "大扫除与旧玩具",
  "不敢说出口的话",
  "新年参拜的心愿",
  "感冒的照顾作战",
  "一起看的深夜电影",
  "晒衣绳上的秘密",
  "社团活动的邀请",
  "夏天的第一支冰棍",
  "比赛加油特攻队",
  "窗边的风铃",
  "留宿的规则变了",
  "藏在床底的信",
  "车站前的偶遇",
  "家庭餐厅的兼职",
  "星空下的约定",
  "尴尬的家长会",
  "慢慢靠近的两个人",
  "被误解的表白",
  "她的过去与现在",
  "雨过天晴",
];

export const chapters: Chapter[] = chapterTitles.map((title, i) => {
  const total = chapterTitles.length;
  const num = i + 1;
  const volume = volumes[Math.floor((num - 1) / 10)] ?? "第4卷";
  const day = 28 - (total - num);
  const month = 8 - Math.floor((total - num) / 12);
  const date = `${month}月${day}日`;
  const pages = 18 + ((num * 7) % 12);
  return { id: num, num, title, volume, date, pages };
});

export const latestChapters: Chapter[] = chapters.slice(0, 6);

export const characters: Character[] = [
  {
    id: 1,
    name: "夏川 凛",
    role: "本作女主角 · 辣妹",
    tag: "外冷内热",
    desc: "住在隔壁的辣妹，因为家里水管爆掉临时借宿男主家。嘴上总是一副无所谓的样子，却会在深夜偷偷给加班的男主留饭。",
    image: "https://bainwo.github.io/api/search-image?query=anime%20illustration%20of%20a%20stylish%20gyaru%20high%20school%20girl%20with%20long%20wavy%20brown%20hair%20and%20a%20small%20gold%20heart%20hairpin%2C%20wearing%20a%20loose%20oversized%20hoodie%20at%20home%2C%20warm%20peach%20and%20cream%20room%20background%2C%20soft%20window%20light%2C%20vibrant%20anime%20manga%20style%2C%20gentle%20expression%2C%20high%20detail&width=600&height=760&seq=char-girl-01&orientation=portrait",
  },
  {
    id: 2,
    name: "星野 悠",
    role: "本作男主角 · 邻居",
    tag: "温柔寡言",
    desc: "住在夏川凛隔壁的普通高中生，性格安静、做事认真。把借宿的凛当作室友来照顾，却在相处中逐渐看清她的另一面。",
    image: "https://bainwo.github.io/api/search-image?query=anime%20illustration%20of%20a%20calm%20high%20school%20boy%20with%20short%20black%20hair%20wearing%20a%20plain%20white%20t-shirt%2C%20soft%20smile%2C%20warm%20cream%20and%20peach%20room%20background%2C%20soft%20natural%20lighting%2C%20clean%20anime%20manga%20style%2C%20gentle%20and%20approachable%2C%20high%20detail&width=600&height=760&seq=char-boy-01&orientation=portrait",
  },
  {
    id: 3,
    name: "水野 桃",
    role: "凛的好友",
    tag: "活泼元气",
    desc: "凛的青梅竹马兼同班好友，性格开朗爱凑热闹。总能精准地戳破凛的口是心非，是本作气氛担当。",
    image: "https://bainwo.github.io/api/search-image?query=anime%20illustration%20of%20a%20cheerful%20petite%20high%20school%20girl%20with%20twin%20buns%20and%20blunt%20bangs%2C%20wearing%20a%20yellow%20cardigan%2C%20bright%20laughing%20expression%2C%20warm%20peach%20background%2C%20playful%20anime%20manga%20style%2C%20energetic%20and%20cute%2C%20high%20detail&width=600&height=760&seq=char-girl2-01&orientation=portrait",
  },
  {
    id: 4,
    name: "藤原 飒",
    role: "悠的损友",
    tag: "爱起哄",
    desc: "星野悠的同班损友，总爱拿借宿这件事打趣悠。看似吊儿郎当，关键时刻却很讲义气。",
    image: "https://bainwo.github.io/api/search-image?query=anime%20illustration%20of%20a%20laid-back%20high%20school%20boy%20with%20messy%20light%20hair%20and%20a%20mischievous%20grin%2C%20wearing%20a%20hooded%20jacket%2C%20warm%20cream%20and%20peach%20background%2C%20casual%20anime%20manga%20style%2C%20playful%20and%20relaxed%2C%20high%20detail&width=600&height=760&seq=char-boy2-01&orientation=portrait",
  },
];

export const faqs = [
  {
    q: "《泡在我家的辣妹》现在更新到第几话了？",
    a: "目前汉化进度已更新到第35话，最新话为《雨过天晴》。本站会第一时间同步最新话更新进度与标题，刷新「最新更新」板块即可看到最新内容。",
  },
  {
    q: "泡在我家的辣妹完结了没有？",
    a: "截至当前更新，漫画尚未完结，仍在连载中。第1卷至第4卷的正文均已收录，后续章节会随官方发布持续补充，建议关注本页更新进度。",
  },
  {
    q: "如何查看完整的漫画全集目录？",
    a: "进入页面的「全集目录」板块，可按卷（第1卷至第4卷）筛选章节，也可以在搜索框输入章节标题关键词快速定位，每一话都标注了话数、标题与收录卷数。",
  },
  {
    q: "漫画下载入口在哪里？",
    a: "本站提供每话的直达下载入口，点开任意章节卡片即可进入对应内容页，页面内会提供当前话的下载与阅读入口，无需跨站到处找资源。",
  },
  {
    q: "为什么有些章节显示「汉化中」？",
    a: "当官方发布新话后，汉化需要一定处理时间。处于汉化中的章节会保留占位状态，处理完成后会自动上架并出现在最新更新列表顶部。",
  },
  {
    q: "内容会收费吗？需要注册账号吗？",
    a: "浏览全集目录与更新进度完全免费，无需注册账号即可使用。我们会持续维护更新进度与目录信息，方便读者快速追更。",
  },
];

export const synopsisParagraphs = [
  "因为一场水管爆裂的小事故，隔壁那位漂亮又张扬的辣妹——夏川凛，抱着行李敲开了普通高中生星野悠的家门。「就借住几天，不会给你添麻烦的。」她嘴上这么说，却从第一天起就让这个安静的出租屋悄悄变了样。",
  "清晨厨房里笨拙的煎蛋、深夜客厅里抢着看的零食、雨天只剩一把的伞……两个生活节奏完全不同的年轻人，在同一个屋檐下慢慢靠近。凛习惯用玩笑和嘴硬掩饰真心，悠则用沉默和体贴一点点看穿她的伪装。",
  "随着日常变得热闹，藏在凛过去的秘密、邻居的闲言碎语、以及两人谁都不肯先开口的心意，正把这段借宿关系推向无法回头的方向。《泡在我家的辣妹》用轻松又温柔的笔触，讲述一段关于接纳、陪伴与成长的同居日常。",
];

export const guideSteps = [
  {
    icon: "ri-focus-3-line",
    title: "认准更新源",
    desc: "本站聚合官方与汉化组的更新动态，首页「最新更新」始终置顶显示当前最新话，点开即可直达内容，不用再四处比对进度。",
  },
  {
    icon: "ri-book-open-line",
    title: "按卷或搜索翻阅",
    desc: "在「全集目录」中可先按卷定位再逐话阅读，也能用关键词搜索章节标题，追更到一半回来补前面的内容也很方便。",
  },
  {
    icon: "ri-download-cloud-2-line",
    title: "下载与阅读",
    desc: "每话卡片提供对应内容入口，支持在线阅读与离线下载。下载资源会随汉化更新自动同步，点开即可直达最新内容。",
  },
  {
    icon: "ri-question-line",
    title: "卡住了看 FAQ",
    desc: "关于完结进度、汉化状态、下载方式等高频疑问，都可以在「常见问题」里快速找到答案，省去反复询问的时间。",
  },
];